import React from "react";
import { observer, inject } from "mobx-react";
import ReactMarkdown from "react-markdown";
import * as M from "@material-ui/core";

const Boarding = ({ store }) => {
  const { $user, $locale } = store;
  return (
    <M.Dialog
      open={$user.sessionUser.boarding}
      maxWidth={"sm"}
      fullWidth
      onClose={() => {
        $user.sessionUser.change("boarding", false);
        $user.sessionUser.save();
      }}
    >
      <M.DialogTitle>{$locale.t("boarding_title")}</M.DialogTitle>
      <M.DialogContent>
        <ReactMarkdown source={$locale.t("boarding_body")} renderers={{ link: LinkRenderer }} />
      </M.DialogContent>
      <M.DialogActions>
        <M.Button
          color="secondary"
          onClick={() => {
            window.open(process.env.PUBLIC_URL + "/handleiding_secundair.docx", "_blank");
          }}
        >
          {"download Handleiding Secundair"}
        </M.Button>
        <M.Button
          color="secondary"
          onClick={() => {
            window.open(process.env.PUBLIC_URL + "/handleiding.docx", "_blank");
          }}
        >
          {"download Handleiding"}
        </M.Button>
        <M.Button
          onClick={() => {
            $user.sessionUser.change("boarding", false);
            $user.sessionUser.save();
          }}
        >
          {"Ga verder"}
        </M.Button>
      </M.DialogActions>
    </M.Dialog>
  );
};

function LinkRenderer(props) {
  return (
    <a href={props.href} target="_blank">
      {props.children}
    </a>
  );
}

export default inject("store")(observer(Boarding));
